var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.0024L8 16.0024H16C17.1 16.0024 18 15.1024 18 14.0024C18 12.9024 17.1 12.0024 16 12.0024H12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06 3.19238L0.29 11.9624C0.11 12.1424 0 12.4024 0 12.6624V15.0024C0 15.5524 0.45 16.0024 1 16.0024H3.34C3.61 16.0024 3.86 15.8924 4.05 15.7124L12.82 6.94238L9.06 3.19238Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7099 4.0425C16.0999 3.6525 16.0999 3.0225 15.7099 2.6325L13.3699 0.2925C12.9799 -0.0975 12.3499 -0.0975 11.9599 0.2925L10.1299 2.1225L13.8799 5.8725L15.7099 4.0425Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.297ca63c2fe2d60aa75223a42e980072.svg";
export { ForwardRef as ReactComponent };